/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import {
  Col,
  DatePicker,
  FloatButton,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Typography,
} from "antd";
import { MetaTags } from "react-meta-tags";
import { CommentOutlined, CloseOutlined } from "@ant-design/icons";
import CareerLogo from "../../../assets/images/header-career.jpg";
import SubmitCV from "../../../assets/images/submit_cv.jpg";
import PrideLogo from "../../../assets/images/pride3.jpg";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";
import { connectWithList, designationList } from "./data";

const Careers = (props) => {
  const media = useMedia();
  // const packageDetailsData =
  //   props && props.location && props.location.state ? props.location.state : "";

  //Initial state

  const [chatModal, setChatModal] = useState(false);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  console.log(windowDimensions, "windowDimensions");

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Join with us | Plan mi trip</title>
        </MetaTags>
      </div>
      <Row>
        <Col
          md={24}
          sm={24}
          xs={24}
          lg={24}
          xl={24}
          xxl={24}
          className="mt-[-20px]"
        >
          <Image
            src={CareerLogo}
            preview={false}
            width={"100%"}
            // className=""
            // style={{
            //   objectFit: "cover",
            //   backgroundPosition: "cover",
            //   display: "block",
            // }}
            // height={"100%"}
            height={280}
          />
        </Col>
      </Row>
      <Row
        className={
          media == "sm"
            ? "pr-[6%] pl-[6%] w-[100%]"
            : media == "xs"
            ? "pr-[40px] pl-[40px] w-[100%]"
            : media == "md"
            ? "pr-[7%] pl-[7%] w-[100%]"
            : media == "lg"
            ? "pr-[10%] pl-[10%] w-[100%] mt-[80px]"
            : media == "xxl"
            ? "pr-[1%] pl-[11%] w-[100%]"
            : "pr-[8%] pl-[6.5%] w-[100%]"
          // media === "md"
          //   ? "mt-10 pl-[140px] pr-[120px] w-[100%]"
          //   : media == "sm" || media == "xs"
          //   ? "pl-[40px] pr-[30px] w-[100%]"
          //   : "pl-[140px] pr-[120px] w-[100%]"
        }
      >
        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24} className="">
          <Row className="mt-3">
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-3"
            >
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[28px] text-[#eb3a3e] font-semibold mb-[5px]"
              >
                About Plan Mi Trip
              </div>
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-8"
            >
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <p className="text-[18px] font-normal mb-3">
                    Plan mi trip Travel Limited (Formerly Plan mi trip Travel
                    Pvt. Ltd.) is a step-down subsidiary of Fairfax Financial
                    Holdings Group; held through its Indian listed subsidiary,
                    Thomas Cook (India) Limited (TCIL). Plan mi trip India is a
                    leading travel and tourism company active across various
                    travel segments including Leisure Travel, Incentive Travel
                    and Business Travel.
                  </p>
                  <p className="text-[18px] font-normal mt-5 mb-3">
                    Plan mi trip was established in 1949. Since then, it has
                    escorted lakhs of travelers across the globe for more than
                    70 years to various destinations around the world. It is one
                    of the leaders in segments, namely Escorted Group Tours,
                    Customised Holidays, Holidays of India and Incentive Travel
                    amongst others. Plan mi trip’s customer focus, innovation
                    and operational excellence has not only tapped the existing
                    market potential but has also created new markets through
                    innovative packages. Its vast array of holiday services is
                    taking holidaying to an entirely new level. A new age
                    innovative holiday maker, Plan mi trip strives to make
                    holidays a priority for every Indian. Through investments in
                    technology and with a strong online presence the company
                    serves its customers through an omni-channel play.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-3"
            >
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[28px] text-[#eb3a3e] font-semibold mb-[5px]"
              >
                Connect - Transform - Grow with Us
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="flex justify-center w-[100%] text-[20px] mt-3 mb-[5px]"
              >
                <div
                  style={{
                    borderRadius: "40px",
                    width:
                      media === "md" || media === "sm" || media === "xs"
                        ? "60%"
                        : "40%",
                  }}
                  className="pl-4 pr-4 pt-2 pb-2 text-center career-connect-with-us text-[#eb3a3e] font-semibold rounded-xxl"
                >
                  At Plan Mi Trip we take interest in
                </div>
              </div>
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-8"
            >
              <Row>
                {connectWithList.map((data, index) => {
                  return (
                    <Col
                      style={{
                        fontFamily: "Poppins",
                      }}
                      key={index}
                      md={8}
                      sm={24}
                      xs={24}
                      lg={8}
                      xl={8}
                      xxl={8}
                      className={
                        (index !== 2 && (media !== "sm" || media !== "xs")) ||
                        media == "sm" ||
                        media == "xs"
                          ? "pr-3"
                          : "pr-0"
                      }
                    >
                      <div
                        className={
                          media == "sm" || media == "xs"
                            ? "w-[100%] border border-1 mb-3"
                            : media == "md"
                            ? "w-[100%] h-[610px] border border-1"
                            : media == "lg"
                            ? "w-[100%] h-[520px] border border-1"
                            : "w-[100%] h-[440px] border border-1"
                        }
                      >
                        <Image
                          src={data.imageUrl}
                          preview={false}
                          width={"100%"}
                          height={160}
                          alt={data.title}
                        />
                        <div
                          className={
                            index !== 2
                              ? "pl-3 pr-3 pb-5"
                              : "pl-3 pr-3 pb-[63px]"
                          }
                        >
                          <h1 className="mt-5 text-[#eb3a3e] text-[16px] font-semibold uppercase">
                            {data.title}
                          </h1>
                          <p className="mt-2">{data.description}</p>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            {/* <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-8 pr-4 pl-4"
            >
              <Row>
                <Image
                  src={PrideLogo}
                  preview={false}
                  width={"100%"}
                  height={450}
                  alt={"Pride"}
                />
              </Row>
            </Col> */}
          </Row>
          {/* <Row className="mt-3">
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-3"
            >
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[28px] text-[#eb3a3e] font-semibold mb-[5px]"
              >
                Work With Us
              </div>
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mt-8"
            >
              <Row>
                {designationList.map((data, index) => {
                  return (
                    <Col
                      style={{
                        fontFamily: "Poppins",
                      }}
                      key={index}
                      md={12}
                      sm={24}
                      xs={24}
                      lg={6}
                      xl={6}
                      xxl={6}
                      className={
                        index !== 3 || index !== 7 || index !== 11
                          ? "pr-6"
                          : "pr-0"
                      }
                      onClick={() =>
                        document.getElementById("work-with-us").scrollIntoView()
                      }
                    >
                      <div
                        className={
                          media === "sm" || media === "xs"
                            ? "flex justify-center w-[100%]"
                            : "w-[100%]"
                        }
                      >
                        <Image
                          src={data.imageUrl}
                          preview={false}
                          width={
                            media === "sm" || media === "xs" ? "50%" : "100%"
                          }
                          height={media === "sm" || media === "xs" ? 180 : 240}
                          className="cursor-pointer"
                          alt={data.title}
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row> */}
          <Modal
            open={chatModal}
            title=""
            maskClosable={false}
            onClose={() => setChatModal(false)}
            // onCancel={() => setChatModal(false)}
            // onCancel={false}
            closable
            footer={null}
            closeIcon={
              <CloseOutlined
                onClick={() => setChatModal(false)}
                className="text-[#ffffff]"
              />
            }
            width={600}
          >
            {/* <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          /> */}
            <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
              <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
                <Row>
                  <Col
                    style={{
                      fontFamily: "Poppins",
                    }}
                    md={12}
                    sm={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="p-3"
                  >
                    <h2 className="text-[#ffffff]">
                      Don't miss out on our exclusive deals & insider only
                      offers!
                    </h2>
                    <div className="text-[#ffffff] mt-2">
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        5 years of Experience in India
                      </div>
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        Packages across 50 + Countries
                      </div>
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        Best Travel Partner of India
                      </div>
                    </div>
                  </Col>
                  <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
                </Row>
              </div>
            </Col>

            {/* <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          /> */}
          </Modal>
          <FloatButton
            className="w-[50px] h-[50px]"
            type="primary"
            style={{
              margin: "-7px",
            }}
            onClick={() => setChatModal(!chatModal)}
            icon={<CommentOutlined />}
          />
        </Col>
      </Row>
      <Row className="bg-[#ff2c2c5e] mt-[70px]" id="work-with-us">
        <Col
          sm={24}
          xs={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          className={
            media == "sm" || media == "xs" ? "pl-0 mt-[80px]" : "pl-[70px] mt-4"
          }
        >
          {/* <Image src={ContactUsLogo} preview={false} width={400} height={350} /> */}

          <Row className="p-3">
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              className="pr-3 mb-2"
              style={{
                fontFamily: "Poppins",
              }}
            >
              <Input
                name="prefixValue"
                className={"rounded-md h-[40px] input-label p-3"}
                placeholder="Enter name"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2"
            >
              <Input
                name="mail"
                className={"rounded-md h-[40px] input-label p-3"}
                placeholder="Enter mail"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <Input
                name="mail"
                className={"rounded-md h-[40px] input-label p-3"}
                placeholder="Enter mobile no"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <Select
                name="gender"
                options={[]}
                className={"w-[100%] rounded-md input-label h-[45px]"}
                placeholder="Select Gender"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <DatePicker
                name="date"
                options={[]}
                className={"w-[100%] rounded-md input-label h-[45px]"}
                placeholder="Date of Birth"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <Select
                name="qualification"
                options={[]}
                className={"w-[100%] rounded-md input-label h-[45px]"}
                placeholder="Qualification"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <Select
                name="location"
                options={[]}
                className={"w-[100%] rounded-md input-label h-[45px]"}
                placeholder="Select Location"
              />
            </Col>
            <Col
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <Select
                name="areaOfInterest"
                options={[]}
                className={"w-[100%] rounded-md input-label h-[45px]"}
                placeholder="Area of Interest"
              />
            </Col>
            <Col
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-2 mt-2"
            >
              <Select
                name="experience"
                options={[]}
                className={"w-[100%] rounded-md input-label h-[45px]"}
                placeholder="Select Experience"
              />
            </Col>
            <Col
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              xs={24}
              sm={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="pr-3 mb-1 mt-2"
            >
              <Typography
                style={{
                  fontFamily: "Poppins",
                }}
                className="input-label mb-2 text-[18px] font-extrabold"
              >
                Upload Resume
              </Typography>
              <Input
                id="exampleFile"
                name="file"
                type="file"
                className="input-label"
              />
              <Typography
                style={{
                  fontFamily: "Poppins",
                }}
                className="input-label mb-2 mt-1 text-[12px] font-extrabold"
              >
                (Maximum file size 3 MB, File format: .doc, .docx, .pdf)
              </Typography>
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              style={{
                fontFamily: "Poppins",
              }}
              className="flex justify-center pr-3 mb-2 mt-5"
            >
              <div
                className={
                  media == "sm" || media == "xs"
                    ? "w-[100%] hover bg-[#eb3e43] text-center hover:bg-[red] h-[30px] text-[14px] mt-1"
                    : "w-[50%] hover bg-[#eb3e43] text-center hover:bg-[red] h-[40px] text-[16px] mt-1"
                }
                style={{
                  borderRadius: "20px",
                  fontFamily: "Poppins",
                  fontWweight: 800,
                  color: "white",
                  cursor: "pointer",
                  marginTop: "3px",
                  padding: "10px",
                  zIndex: 20,
                }}
              >
                Submit
              </div>
            </Col>
          </Row>
        </Col>
        <Col
          sm={24}
          xs={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          className={
            media == "sm" || media == "xs" ? "pl-0 mt-[80px]" : "pl-4 mt-4"
          }
        >
          {/* <Image src={ContactUsLogo} preview={false} width={400} height={350} /> */}

          <Row className="p-3">
            <Col sm={24} xs={24} md={24} lg={24} xl={24} xxl={24}>
              <Image
                src={SubmitCV}
                preview={false}
                width={"100%"}
                className="border border-1 rounded-md"
                height={450}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

Careers.propTypes = {
  location: PropTypes.any,
};

export default withRouter(Careers);
